module.exports = __webpack_public_path__ + "static/scale-model-of-riverwalk-fort-lauderdale-in-hollywood-florida-eb20ab95767bf5584e421893b7032882.png";